import React from 'react';

/* 공장/설비 관리 폼의 한 칸 — 라벨(+필수 표시) 아래에 입력이나 조회 값을 둔다. full 이면 두 열을 모두 쓴다. */
function MgField({ label, required = false, full = false, children }) {
  return (
    <div className={`mg-group ${full ? 'full' : ''}`}>
      <label className="mg-label">
        {label}
        {required && <span className="mg-required">*</span>}
      </label>
      {children}
    </div>
  );
}

export default MgField;
